import { Injectable, ComponentFactory } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as enums from '../common/enums';
import { MsgMngrService } from '../msg/msg-mngr.service';
import { AspObject } from '../asp/AspObject';
import { UserActionComponent } from './user-action.component';
import { IMapClickHandler } from '../asp/interfaces';
import { ObjectsMenuService } from '../menu-bars/objects-menu.service';
import { MsgBoxService } from '../msg-boxes/msg-box.service';
import { MsgHandler } from '../msg/msgHandler';
import { mainMapSelectionTool } from '../asp/aspSettings';
import { UserActionMsg } from '../msg/msgs';
import * as consts from '../common/consts';
import { AppConfig } from '../app.config';

// Handle user action response
export interface IUserActionResponder {
  // Handle response
  // status: True if user completed the action, false if aborted
  // objects: An array of objects picked by the user
  // data: Optional data entered by user in the action's dialog
  response(action: number, status: boolean, objects?: AspObject[], data?: any): void;
}

@Injectable({
  providedIn: 'root'
})
export class UserActionService extends MsgHandler implements IMapClickHandler {
  private dialogRef: MatDialogRef<any, any>;
  private action: number;
  private actionObj: AspObject;

  constructor(private dialog: MatDialog, private msgMngr: MsgMngrService, private msgBox: MsgBoxService, private objectsMenu: ObjectsMenuService) {
    super(consts.MSG_TYPE_USER_ACTION_STATUS);
  }

  activateAction(action: number, prompt: string, obj: AspObject, responder: IUserActionResponder,
    bodyFactory: ComponentFactory<any>, okButtonShown: boolean = false, cursor: string = 'pointer') {
    if (this.isActionActive())
      return;

    this.action = action;
    this.actionObj = obj;

    let title = consts.constsMngr.userActionTitle(action);
    if (title.endsWith('...'))
      title = title.substr(0, title.length - 3);

    this.dialogRef = this.dialog.open(UserActionComponent, UserActionComponent.createDialogConfig(title, prompt, obj));
    this.dialogRef.afterClosed().subscribe(result => {
      typeof result == 'undefined' ?
        responder.response(action, false) :
        responder.response(action, result.status, result.objects, result.data);
      mainMapSelectionTool.setMapClickHandler(null);
    });

    let userActionComp = this.dialogRef.componentInstance as UserActionComponent;

    if (bodyFactory)
      userActionComp.setBodyComponentFactory(bodyFactory);
    if (okButtonShown)
      userActionComp.showOkButton();

    mainMapSelectionTool.setMapClickHandler(this, cursor);
  }

  isActionActive(): boolean {
    return this.dialog.getDialogById(UserActionComponent.DIALOG_ID) !== undefined;
  }

  onObjectsClicked(objects: AspObject[]) {
    let validObjects: AspObject[] = objects.filter(obj => obj.objectsPool.canBePicked(this.action, this.actionObj, obj));
    if (validObjects.length == 1)
      this.dialogRef.close({ status: true, objects: validObjects });
    else if (validObjects.length > 1)
      this.objectsMenu.showObjectsMenu(validObjects, event, null, this);
  }

  // Send user action to server
  // Note: This will allow for action/status monitoring
  sendUserAction(userAction: UserActionMsg) {
    this.msgMngr.send(userAction);
  }

  // Defined in MsgHandler
  // Note: Handle status of user action sent by sendUserAction()
  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs) {
      console.log("useraction msg:", msgObj);
      let message = '';
      if (msgObj.message)
        message = msgObj.message.trim();
      if (msgObj.status == enums.UserActionStatus.Success) {
        if (message.length == 0)
          message = 'Operation completed successfully';
        this.msgBox.showSuccessMsg(message);
      }
      else {
        if (message.length == 0)
          message = 'Operation failed';
        this.msgBox.showErrorMsg(message);
      }
    }
  }
}
